import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const checkboxSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.checkbox, {
        base: {
            root: {
                my: 0,
            },
            control: {
                mt: 0,
                borderRadius: 'sm',
                borderWidth: '2px',
            },
            label: {
                fontWeight: 'normal',
            },
        },
        variants: {
            variant: {
                solid: {
                    control: {
                        bg: 'white',
                        borderColor: '{colors.gray.400}',
                        _invalid: {
                            borderColor: '{colors.red.solid}',
                        },
                    },
                },
            },
            size: {
                md: {
                    root: {
                        gap: 2,
                    },
                },
                lg: {
                    control: {
                        width: {
                            base: '16px',
                            md: '18px',
                        },
                        height: {
                            base: '16px',
                            md: '18px',
                        },
                        mt: {
                            base: '1px',
                            md: '3px',
                        },
                    },
                },
            },
        },
    }),
);
